export default __webpack_public_path__ + "static/media/1423.f2562e9a.jpg";